import { useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { useGetAccountSchema } from '../services/SchemaService';
import { pageConfigs } from './pageConfigs';

export const useGetTemplate = (pageName: string) => {
    const navigate = useNavigate();
    const { data: schemaData } = useGetAccountSchema();
    
    return useQuery(['getTemplate', pageName], () => {
        try {
            
            const templateData = pageConfigs[pageName as keyof typeof pageConfigs];
            
            if (!templateData || Object.keys(templateData).length === 0 || 
                !schemaData || Object.keys(schemaData).length === 0) {
                navigate('/template-not-found');
                throw new Error('Template não encontrado');
            }

            if (schemaData[pageName]) {
                return {
                    ...templateData,
                    ...schemaData[pageName]
                };
            }

            return templateData;
        } catch (error) {
            navigate('/template-not-found');
            
            return {};
        }
    }, {
        enabled: !!pageName && !!schemaData,
        staleTime: Infinity,
        cacheTime: Infinity,
        refetchOnMount: false,
        refetchOnWindowFocus: false
    });
}; 